import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from "@mui/material";
import { useSelector } from "react-redux";
import ChangeRow from "./ChangeRow";
import { fixNumber } from "../../shared/util/functions";

const ChangeTable = () => {
	const rows = useSelector((state) => state.ReceiptReducer.orders);

	return (
		<TableContainer
			component={Paper}
			sx={{ backgroundColor: "pallete.primary" }}
		>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell align="justify"></TableCell>
						<TableCell align="justify">نام پزشک</TableCell>
						<TableCell align="justify">نام بیمار</TableCell>
						<TableCell align="justify">نوع کار</TableCell>
						<TableCell align="justify">تعداد واحد</TableCell>
						<TableCell align="justify">قیمت واحد</TableCell>
						<TableCell align="justify">قیمت کل</TableCell>
						<TableCell align="justify">پس از تخفیف</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row) => (
						<ChangeRow
							key={row.orderId}
							orderId={row.orderId}
							doctorName={row.doctorName}
							patientName={row.patientName}
							orderType={row.orderTypeName}
							unitCount={fixNumber(row.unitCount)}
							unitPrice={fixNumber(row.unitCost)}
							totalPrice={fixNumber(row.totalCost)}
							discountPrice={fixNumber(row.afterDiscount)}
							details={row.details}
						/>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default ChangeTable;
